import _extends from "@babel/runtime-corejs3/helpers/extends";
import { createVNode as _$cv, className as _$cn, createUnknownComponentVNode as _$cc, createElementVNode as _$ce } from 'intact-vue';
import { Tooltip } from '../tooltip';
import { getRestProps } from '../utils';
import { makeStyles } from './styles';
import { ColorpickerPanel } from './panel';
import { Dropdown, DropdownMenu } from '../dropdown';
export default function ($props, $blocks, $__proto__) {
  var _classNameObj;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _this$get = this.get(),
    className = _this$get.className,
    transition = _this$get.transition,
    presets = _this$get.presets,
    value = _this$get.value,
    size = _this$get.size,
    disabled = _this$get.disabled,
    container = _this$get.container,
    position = _this$get.position;
  var k = this.config.k;
  var classNameObj = (_classNameObj = {}, _classNameObj[k + "-colorpicker"] = true, _classNameObj[className] = className, _classNameObj[k + "-" + size] = size !== 'default', _classNameObj[k + "-disabled"] = disabled, _classNameObj[makeStyles(k)] = true, _classNameObj);
  return _$cv('div', _extends({
    'className': _$cn(classNameObj)
  }, getRestProps(this)), _$cc(Dropdown, {
    'position': position,
    'trigger': 'click',
    'disabled': disabled,
    'container': container,
    'children': [_$ce(2, 'div', _$ce(2, 'div', null, 1, _$cn(k + "-colorpicker-inner"), {
      'style': {
        backgroundColor: value
      }
    }), 2, _$cn(k + "-colorpicker-color")), _$cc(DropdownMenu, {
      'className': _$cn(k + "-colorpicker-content"),
      'children': _$cc(ColorpickerPanel, {
        'presets': presets,
        'ev-$model:value': function ev$modelValue($v) {
          $this.set('value', $v);
        },
        'value': $this.get('value')
      })
    })],
    'ev-$model:value': function ev$modelValue($v) {
      $this.set('show', $v);
    },
    'value': $this.get('show')
  }));
}
;